export const PAYMENT_PAGE_AA = '/subPackage/order/pay';
export const CHECKOUT_AA_SESSION_TIMER_MINUTES = 15;
